var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.activeStep == 0
      ? _c("div", { staticClass: "container" }, [
          _c(
            "div",
            {
              class: [
                !_vm.aanvraagGa.isAanvraagGA
                  ? "alert alert-danger text-left"
                  : "alert alert-secondary text-left"
              ],
              attrs: { role: "alert" }
            },
            [
              _c("div", { staticClass: "form-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.aanvraagGa.isAanvraagGA,
                      expression: "aanvraagGa.isAanvraagGA"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: {
                    type: "checkbox",
                    id: "inlineCheckbox1",
                    checked: "false",
                    "true-value": false,
                    "false-value": true,
                    disabled: _vm.aanvraagNeedsInfo
                  },
                  domProps: {
                    checked: Array.isArray(_vm.aanvraagGa.isAanvraagGA)
                      ? _vm._i(_vm.aanvraagGa.isAanvraagGA, null) > -1
                      : _vm._q(_vm.aanvraagGa.isAanvraagGA, false)
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.aanvraagGa.isAanvraagGA,
                        $$el = $event.target,
                        $$c = $$el.checked ? false : true
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.aanvraagGa,
                              "isAanvraagGA",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.aanvraagGa,
                              "isAanvraagGA",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.aanvraagGa, "isAanvraagGA", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: "inlineCheckbox1" }
                  },
                  [
                    _vm._v(
                      "Ik wens geen aanvraag geldelijke anciënniteit in te dienen."
                    )
                  ]
                )
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.activeStep == 1
      ? _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "div",
              {
                class: [
                  !_vm.aanvraagGa.toestemmingAanvraagLoopbaanFiche
                    ? "alert alert-secondary text-left"
                    : "alert alert-success text-left"
                ],
                attrs: { role: "alert" }
              },
              [
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.aanvraagGa.toestemmingAanvraagLoopbaanFiche,
                        expression:
                          "aanvraagGa.toestemmingAanvraagLoopbaanFiche"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "toestemmingloopbaanfiche",
                      checked: "false",
                      disabled: _vm.aanvraagNeedsInfo
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.aanvraagGa.toestemmingAanvraagLoopbaanFiche
                      )
                        ? _vm._i(
                            _vm.aanvraagGa.toestemmingAanvraagLoopbaanFiche,
                            null
                          ) > -1
                        : _vm.aanvraagGa.toestemmingAanvraagLoopbaanFiche
                    },
                    on: {
                      change: function($event) {
                        var $$a =
                            _vm.aanvraagGa.toestemmingAanvraagLoopbaanFiche,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.aanvraagGa,
                                "toestemmingAanvraagLoopbaanFiche",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.aanvraagGa,
                                "toestemmingAanvraagLoopbaanFiche",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.aanvraagGa,
                            "toestemmingAanvraagLoopbaanFiche",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "toestemmingloopbaanfiche" }
                    },
                    [
                      _vm._v(
                        "Ik geef hierbij toestemming aan de hogeschool om bij het\n          Departement Onderwijs mijn loopbaanfiche op te vragen."
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.aanvraagGa.loopbaanfiches.length
                  ? _c(
                      "div",
                      { staticClass: "container" },
                      [
                        _c("h3", [_vm._v("Hier uw loopbaanfiches")]),
                        _vm._v(" "),
                        _c("loopbaan-fiche", {
                          attrs: {
                            loopbaanFiches: _vm.aanvraagGa.loopbaanfiches
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            !_vm.aanvraagHasToestemmingDepHO
              ? [
                  !_vm.aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs.length
                    ? _c("h5", { staticClass: "text-center mb-3" }, [
                        _vm._v("\n        Geen tewerkstellingen\n      ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(
                    _vm.$v.aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs
                      .$each.$iter,
                    function(tew, index) {
                      return _c(
                        "div",
                        {
                          key: "tew-binnen-ond-" + index,
                          staticClass:
                            "container my-2 border border-primary p-3 bg-light mb-4"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "container text-right mt-n3 mr-n4 mb-2",
                              on: {
                                click: function($event) {
                                  return _vm.deleteTewerkstellingBinnenOnderwijs(
                                    index
                                  )
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "text-danger",
                                attrs: { icon: ["far", "times"] }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs[
                            index
                          ].opmerkingHr
                            ? _c(
                                "info-alert",
                                { attrs: { "color-class": "warning" } },
                                [
                                  _vm._v(
                                    "Melding HR:\n          " +
                                      _vm._s(
                                        _vm.aanvraagGa
                                          .tewerkstellingsGegevensBinnenOnderwijs[
                                          index
                                        ].opmerkingHr
                                      )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isTewerkstellingBuitenOnderwijs(
                            _vm.currentTewGegevens
                          )
                            ? _c("toggle-input", {
                                attrs: {
                                  label:
                                    "Toestemming aanvraag loopbaanfiche HO",
                                  id: "hasToestemmingAanvraagLoopbaanfhicheHO",
                                  labelEnableText: "Ja",
                                  labelDisableText: "Nee"
                                },
                                on: {
                                  change:
                                    _vm.updateToestemmingAanvraagLoopbaanFiche
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          [
                            _c("text-input", {
                              attrs: {
                                label: "Werkgever",
                                id: "tewWerkgever",
                                validationObject:
                                  _vm.$v.aanvraagGa
                                    .tewerkstellingsGegevensBinnenOnderwijs
                                    .$each.$iter[index].werkgever
                              },
                              model: {
                                value:
                                  _vm.aanvraagGa
                                    .tewerkstellingsGegevensBinnenOnderwijs[
                                    index
                                  ].werkgever,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.aanvraagGa
                                      .tewerkstellingsGegevensBinnenOnderwijs[
                                      index
                                    ],
                                    "werkgever",
                                    $$v
                                  )
                                },
                                expression:
                                  "\n              aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs[index]\n                .werkgever\n            "
                              }
                            }),
                            _vm._v(" "),
                            _c("text-input", {
                              attrs: {
                                label: "Functie",
                                id: "tewFunctie",
                                validationObject:
                                  _vm.$v.aanvraagGa
                                    .tewerkstellingsGegevensBinnenOnderwijs
                                    .$each.$iter[index].functie
                              },
                              model: {
                                value:
                                  _vm.aanvraagGa
                                    .tewerkstellingsGegevensBinnenOnderwijs[
                                    index
                                  ].functie,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.aanvraagGa
                                      .tewerkstellingsGegevensBinnenOnderwijs[
                                      index
                                    ],
                                    "functie",
                                    $$v
                                  )
                                },
                                expression:
                                  "\n              aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs[index].functie\n            "
                              }
                            }),
                            _vm._v(" "),
                            _c("date-input", {
                              attrs: {
                                label: "Begindatum",
                                id: "tewStartdatum",
                                required: "true"
                              },
                              model: {
                                value:
                                  _vm.aanvraagGa
                                    .tewerkstellingsGegevensBinnenOnderwijs[
                                    index
                                  ].begindatum,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.aanvraagGa
                                      .tewerkstellingsGegevensBinnenOnderwijs[
                                      index
                                    ],
                                    "begindatum",
                                    $$v
                                  )
                                },
                                expression:
                                  "\n              aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs[index]\n                .begindatum\n            "
                              }
                            }),
                            _vm._v(" "),
                            _c("date-input", {
                              attrs: {
                                label: "Einddatum",
                                id: "tewMotivering",
                                required: "true"
                              },
                              model: {
                                value:
                                  _vm.aanvraagGa
                                    .tewerkstellingsGegevensBinnenOnderwijs[
                                    index
                                  ].einddatum,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.aanvraagGa
                                      .tewerkstellingsGegevensBinnenOnderwijs[
                                      index
                                    ],
                                    "einddatum",
                                    $$v
                                  )
                                },
                                expression:
                                  "\n              aanvraagGa.tewerkstellingsGegevensBinnenOnderwijs[index]\n                .einddatum\n            "
                              }
                            }),
                            _vm._v(" "),
                            _c("file-upload", {
                              attrs: { label: "Tewerkstellingsattest" },
                              on: {
                                "files-changed": function($event) {
                                  return _vm.onFilesChangedBinnenOnderwijs(
                                    $event,
                                    index
                                  )
                                }
                              }
                            })
                          ]
                        ],
                        2
                      )
                    }
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "container text-center" },
                    [
                      _c("plus-button", {
                        attrs: { label: "Voeg toe" },
                        on: {
                          click: function($event) {
                            return _vm.addNewTewerkstellingBinnenOnderwijs()
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.activeStep == 2
      ? _c(
          "div",
          { staticClass: "container" },
          [
            !_vm.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt.length
              ? _c("h5", { staticClass: "text-center mb-3" }, [
                  _vm._v("\n      Geen tewerkstellingen\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(
              _vm.$v.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt.$each.$iter,
              function(tew, index) {
                return _c(
                  "div",
                  {
                    key: "tew-openbaar-ambt-" + index,
                    staticClass:
                      "container my-2 border border-primary p-3 bg-light mb-4"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container text-right mt-n3 mr-n4 mb-2",
                        on: {
                          click: function($event) {
                            return _vm.deleteTewerkstellingOpenbaarAmbt(index)
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "text-danger",
                          attrs: { icon: ["far", "times"] }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[index]
                      .opmerkingHr
                      ? _c(
                          "info-alert",
                          { attrs: { "color-class": "warning" } },
                          [
                            _vm._v(
                              "Melding HR:\n        " +
                                _vm._s(
                                  _vm.aanvraagGa
                                    .tewerkstellingsGegevensOpenbaarAmbt[index]
                                    .opmerkingHr
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    [
                      _c("text-input", {
                        attrs: {
                          label: "Werkgever",
                          id: "tewWerkgever",
                          validationObject:
                            _vm.$v.aanvraagGa
                              .tewerkstellingsGegevensOpenbaarAmbt.$each.$iter[
                              index
                            ].werkgever
                        },
                        model: {
                          value:
                            _vm.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[
                              index
                            ].werkgever,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensOpenbaarAmbt[index],
                              "werkgever",
                              $$v
                            )
                          },
                          expression:
                            "\n            aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[index].werkgever\n          "
                        }
                      }),
                      _vm._v(" "),
                      _c("text-input", {
                        attrs: {
                          label: "Functie",
                          id: "tewFunctie",
                          validationObject:
                            _vm.$v.aanvraagGa
                              .tewerkstellingsGegevensOpenbaarAmbt.$each.$iter[
                              index
                            ].functie
                        },
                        model: {
                          value:
                            _vm.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[
                              index
                            ].functie,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensOpenbaarAmbt[index],
                              "functie",
                              $$v
                            )
                          },
                          expression:
                            "\n            aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[index].functie\n          "
                        }
                      }),
                      _vm._v(" "),
                      _c("date-input", {
                        attrs: { label: "Begindatum", id: "tewStartdatum" },
                        model: {
                          value:
                            _vm.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[
                              index
                            ].begindatum,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensOpenbaarAmbt[index],
                              "begindatum",
                              $$v
                            )
                          },
                          expression:
                            "\n            aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[index].begindatum\n          "
                        }
                      }),
                      _vm._v(" "),
                      _c("date-input", {
                        attrs: { label: "Einddatum", id: "tewMotivering" },
                        model: {
                          value:
                            _vm.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[
                              index
                            ].einddatum,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensOpenbaarAmbt[index],
                              "einddatum",
                              $$v
                            )
                          },
                          expression:
                            "\n            aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[index].einddatum\n          "
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "font-weight-bold" }, [
                        _vm._v("Motivering")
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensOpenbaarAmbt[index]
                                .motivering,
                            expression:
                              "\n            aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[index].motivering\n          "
                          }
                        ],
                        staticClass: "form-control mb-2",
                        attrs: {
                          rows: "3",
                          placeholder: "Motivering",
                          type: "text"
                        },
                        domProps: {
                          value:
                            _vm.aanvraagGa.tewerkstellingsGegevensOpenbaarAmbt[
                              index
                            ].motivering
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensOpenbaarAmbt[index],
                              "motivering",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("file-upload", {
                        attrs: { label: "Tewerkstellingsattest" },
                        on: {
                          "files-changed": function($event) {
                            return _vm.onFilesChangedOpenbaarAmbt($event, index)
                          }
                        }
                      })
                    ]
                  ],
                  2
                )
              }
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container text-center" },
              [
                _c("plus-button", {
                  attrs: { label: "Voeg toe" },
                  on: {
                    click: function($event) {
                      return _vm.addNewTewerkstellingOpenbaarAmbt()
                    }
                  }
                })
              ],
              1
            )
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.activeStep == 3
      ? _c(
          "div",
          { staticClass: "container" },
          [
            !_vm.aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs.length
              ? _c("h5", { staticClass: "text-center mb-3" }, [
                  _vm._v("\n      Geen tewerkstellingen\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(
              _vm.$v.aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs.$each
                .$iter,
              function(tew, index) {
                return _c(
                  "div",
                  {
                    key: "tew-buiten-ond-" + index,
                    staticClass:
                      "container my-2 border border-primary p-3 bg-light mb-4"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container text-right mt-n3 mr-n4 mb-2",
                        on: {
                          click: function($event) {
                            return _vm.deleteTewerkstellingBuitenOnderwijs(
                              index
                            )
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "text-danger",
                          attrs: { icon: ["far", "times"] }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs[index]
                      .opmerkingHr
                      ? _c(
                          "info-alert",
                          { attrs: { "color-class": "warning" } },
                          [
                            _vm._v(
                              "Melding HR:\n        " +
                                _vm._s(
                                  _vm.aanvraagGa
                                    .tewerkstellingsGegevensBuitenOnderwijs[
                                    index
                                  ].opmerkingHr
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    [
                      _c("text-input", {
                        attrs: {
                          label: "Werkgever",
                          id: "tewWerkgever",
                          validationObject:
                            _vm.$v.aanvraagGa
                              .tewerkstellingsGegevensBuitenOnderwijs.$each
                              .$iter[index].werkgever
                        },
                        model: {
                          value:
                            _vm.aanvraagGa
                              .tewerkstellingsGegevensBuitenOnderwijs[index]
                              .werkgever,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensBuitenOnderwijs[index],
                              "werkgever",
                              $$v
                            )
                          },
                          expression:
                            "\n            aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs[index].werkgever\n          "
                        }
                      }),
                      _vm._v(" "),
                      _c("text-input", {
                        attrs: {
                          label: "Functie",
                          id: "tewFunctie",
                          validationObject:
                            _vm.$v.aanvraagGa
                              .tewerkstellingsGegevensBuitenOnderwijs.$each
                              .$iter[index].functie
                        },
                        model: {
                          value:
                            _vm.aanvraagGa
                              .tewerkstellingsGegevensBuitenOnderwijs[index]
                              .functie,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensBuitenOnderwijs[index],
                              "functie",
                              $$v
                            )
                          },
                          expression:
                            "\n            aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs[index].functie\n          "
                        }
                      }),
                      _vm._v(" "),
                      _c("date-input", {
                        attrs: { label: "Begindatum", id: "tewStartdatum" },
                        model: {
                          value:
                            _vm.aanvraagGa
                              .tewerkstellingsGegevensBuitenOnderwijs[index]
                              .begindatum,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensBuitenOnderwijs[index],
                              "begindatum",
                              $$v
                            )
                          },
                          expression:
                            "\n            aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs[index]\n              .begindatum\n          "
                        }
                      }),
                      _vm._v(" "),
                      _c("date-input", {
                        attrs: { label: "Einddatum", id: "tewEinddatum" },
                        model: {
                          value:
                            _vm.aanvraagGa
                              .tewerkstellingsGegevensBuitenOnderwijs[index]
                              .einddatum,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensBuitenOnderwijs[index],
                              "einddatum",
                              $$v
                            )
                          },
                          expression:
                            "\n            aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs[index].einddatum\n          "
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "font-weight-bold" }, [
                        _vm._v("Motivering")
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensBuitenOnderwijs[index]
                                .motivering,
                            expression:
                              "\n            aanvraagGa.tewerkstellingsGegevensBuitenOnderwijs[index]\n              .motivering\n          "
                          }
                        ],
                        staticClass: "form-control mb-2",
                        attrs: {
                          rows: "3",
                          placeholder: "Motivering",
                          type: "text"
                        },
                        domProps: {
                          value:
                            _vm.aanvraagGa
                              .tewerkstellingsGegevensBuitenOnderwijs[index]
                              .motivering
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.aanvraagGa
                                .tewerkstellingsGegevensBuitenOnderwijs[index],
                              "motivering",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("file-upload", {
                        attrs: { label: "Tewerkstellingsattest" },
                        on: {
                          "files-changed": function($event) {
                            return _vm.onFilesChangedBuitenOnderwijs(
                              $event,
                              index
                            )
                          }
                        }
                      })
                    ]
                  ],
                  2
                )
              }
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container text-center" },
              [
                _c("plus-button", {
                  attrs: { label: "Voeg toe" },
                  on: {
                    click: function($event) {
                      return _vm.addNewTewerkstellingBuitenOnderwijs()
                    }
                  }
                })
              ],
              1
            )
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.activeStep == 4
      ? _c(
          "div",
          { staticClass: "container" },
          [
            !_vm.aanvraagGa.onbezoldigdeOnderbrekingen.length
              ? _c("h5", { staticClass: "text-center mb-3" }, [
                  _vm._v("\n      Geen tewerkstellingen\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(
              _vm.$v.aanvraagGa.onbezoldigdeOnderbrekingen.$each.$iter,
              function(tew, index) {
                return _c(
                  "div",
                  {
                    key: "tew-buiten-ond-" + index,
                    staticClass:
                      "container my-2 border border-primary p-3 bg-light mb-4"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container text-right mt-n3 mr-n4 mb-2",
                        on: {
                          click: function($event) {
                            return _vm.deleteOnbezoldigdeOnderbreking(index)
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "text-danger",
                          attrs: { icon: ["far", "times"] }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.aanvraagGa.onbezoldigdeOnderbrekingen[index].opmerkingHr
                      ? _c(
                          "info-alert",
                          { attrs: { "color-class": "warning" } },
                          [
                            _vm._v(
                              "Melding HR:\n        " +
                                _vm._s(
                                  _vm.aanvraagGa.onbezoldigdeOnderbrekingen[
                                    index
                                  ].opmerkingHr
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("date-input", {
                      attrs: { label: "Begindatum", id: "tewStartdatum" },
                      model: {
                        value:
                          _vm.aanvraagGa.onbezoldigdeOnderbrekingen[index]
                            .begindatum,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.aanvraagGa.onbezoldigdeOnderbrekingen[index],
                            "begindatum",
                            $$v
                          )
                        },
                        expression:
                          "aanvraagGa.onbezoldigdeOnderbrekingen[index].begindatum"
                      }
                    }),
                    _vm._v(" "),
                    _c("date-input", {
                      attrs: { label: "Einddatum", id: "tewMotivering" },
                      model: {
                        value:
                          _vm.aanvraagGa.onbezoldigdeOnderbrekingen[index]
                            .einddatum,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.aanvraagGa.onbezoldigdeOnderbrekingen[index],
                            "einddatum",
                            $$v
                          )
                        },
                        expression:
                          "aanvraagGa.onbezoldigdeOnderbrekingen[index].einddatum"
                      }
                    }),
                    _vm._v(" "),
                    _c("text-input", {
                      attrs: {
                        label: "Soort onderbreking",
                        id: "onbezSoortOnderbreking",
                        validationObject: {}
                      },
                      model: {
                        value:
                          _vm.aanvraagGa.onbezoldigdeOnderbrekingen[index]
                            .soortOnderbreking,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.aanvraagGa.onbezoldigdeOnderbrekingen[index],
                            "soortOnderbreking",
                            $$v
                          )
                        },
                        expression:
                          "\n          aanvraagGa.onbezoldigdeOnderbrekingen[index].soortOnderbreking\n        "
                      }
                    })
                  ],
                  1
                )
              }
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container text-center" },
              [
                _c("plus-button", {
                  attrs: { label: "Voeg toe" },
                  on: {
                    click: function($event) {
                      return _vm.addNewOnbezoldigdeOnderbreking()
                    }
                  }
                })
              ],
              1
            )
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.activeStep == 5
      ? _c(
          "div",
          { staticClass: "container" },
          [
            _c("info-alert", { attrs: { "color-class": "primary" } }, [
              _vm._v(
                "Controleer nog eventjes uw gegevens vooraleer u de aanvraag\n      verstuurt."
              )
            ]),
            _vm._v(" "),
            _c("aanvraag-ga-overzicht", {
              attrs: { aanvraagGa: _vm.aanvraagGa }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "container" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }